import { useEffect } from "react";
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $insertNodes,
  $isElementNode,
} from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateNodesFromDOM } from "@lexical/html";

type Props = {
  html: string;
  shouldLoad: boolean;
};

export default function LoadHtmlPlugin({ html, shouldLoad }: Props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.update(() => {
      const normalizeHTML = (html: string): string => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        const newChildren: Node[] = [];

        wrapper.childNodes.forEach((node) => {
          if (
            node.nodeType === Node.TEXT_NODE ||
            (node.nodeType === Node.ELEMENT_NODE &&
              ["SPAN", "B", "I", "A", "U", "STRONG", "EM", "BR"].includes(
                node.nodeName
              ))
          ) {
            const p = document.createElement("p");
            p.appendChild(node.cloneNode(true));
            newChildren.push(p);
          } else if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.nodeName !== "SCRIPT"
          ) {
            newChildren.push(node);
          }
        });

        wrapper.innerHTML = ""; // clear
        newChildren.forEach((n) => wrapper.appendChild(n));

        return wrapper.innerHTML;
      };

      const normalizedHTML = normalizeHTML(html);
      const dom = new DOMParser().parseFromString(normalizedHTML, "text/html");
      const nodes = $generateNodesFromDOM(editor, dom);

      const root = $getRoot();
      root.clear();

      for (const node of nodes) {
        if ($isElementNode(node)) {
          root.append(node);
        } else {
          const p = $createParagraphNode();
          p.append(node);
          root.append(p);
        }
      }
    });
  }, [editor, html]);

  return null;
}
